var exports = {
  "jD": "skeletonItem__pF3uxv",
  "wp": "itemTitle__lNqXDV",
  "qi": "itemTitleInner__Wo5Gyo",
};

module.exports = exports;
